export default __webpack_public_path__ + "static/media/coatl.36d832f8.png";